import styled from 'styled-components';
import posed from 'react-pose';

const PosedCollapsibleItem = posed.div(
  ({ animationDuration }: { animationDuration: number }) => ({
    enter: {
      height: 'auto',
      opacity: 1,
      transition: { height: { duration: animationDuration } },
    },
    exit: {
      height: 0,
      opacity: 0,
      transition: {
        height: { duration: animationDuration },
        opacity: { duration: animationDuration },
      },
    },
  }),
);

export const CollapsibleItem = styled(PosedCollapsibleItem)`
  overflow: hidden;
`;
